const baseImgURL = "https://d3etfstcuyoos5.cloudfront.net/app-images/imgs/"

export { baseImgURL };
